import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface SuppliesRequest {
    category: string;
    limit: string;
    page: number;
    searchtxt: string;
    result: string;
}
export type DataListProps = {
    list_no: number;
    bl_no: string;
    subject: string;
    is_app?: boolean; // 앱(모바일) 신청 여부
    company: string;
    boss: string; // 대표자
    name: string;
    mobile: string;
    w_date: string;
    result: number;
    result_texT: string;
    comment: boolean;
    comment_count: number;
};

export interface SuppliesResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleTrackingSupplies = ({
    category,
    page,
    limit,
    searchtxt,
    result,
}: SuppliesRequest): UseQueryResult<SuppliesResponseData, Error> => {
    let url = enum_api_uri.get_console_way_bill.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsoleTrackingSupplies", category, page, limit, searchtxt, result],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                    search: "all_search",
                    searchtxt,
                    ...(result !== "all" && { result }),
                },
            });
            return response.data.data;
        },
    });
};
